import { Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import React, { useContext, useEffect, useState } from 'react';
import { IMAGES } from '../../constants/Images';
import { COLORS } from '../../constants/Colors';
import { SX_STYLES } from '../../styles/components/header/NavigationBarStyles';
import { services } from '../../helper/navigation';
import { ServicesContext } from '../provider/ServicesProvider';
import { ROUTES } from '../../constants/Routes';
import RoundedOptionButton from '../cores/RoundedOptionButton';
import { LABELS } from '../../constants/Labels';
import { useNavigate, useLocation } from 'react-router-dom';

const  NavigationBar = (props) => {
    const servicesContext = useContext(ServicesContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMobileNav = (val) => {
        setDrawerOpen(false);
        handleClick(val);
    }

    const handleMobileContact = () => {
        setDrawerOpen(false);
        goToContactUs();
    }

    const handleClick = (val) => {
        servicesContext.setBreadCrumbs([{crumb: LABELS.HOME, navigateTo: ROUTES.HOME}]);
        navigate(val.route);
        if(val.route === ROUTES.ABOUT_US){
            servicesContext.setIsClickedContact(false)
        }
    }

    const goToContactUs = () => {
        navigate(ROUTES.ABOUT_US);
        servicesContext.setIsClickedContact(true);
    }
    const handleContactUs = () => {
        navigate(ROUTES.ABOUT_US,   { state: { targetId: "talktous" }  })
        
    }
    
    return (
        <>
        <Box sx={[
            SX_STYLES.navigationContainer,
            scrolled && {
                backgroundColor: 'rgba(255,255,255,0.85)',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
            }
        ]} style={{ transition: 'background-color 0.4s ease, box-shadow 0.4s ease, backdrop-filter 0.4s ease' }}>
            <Box sx={SX_STYLES.navigationWrapper}>
                <Box sx={SX_STYLES.logoContainer} onClick={()=>navigate('/')}>
                    <Box
                        component="img"
                        sx={SX_STYLES.logoStyle}
                        src={IMAGES.HIC_Logo}
                    />
                    <Typography sx={SX_STYLES.logoName}>HUNDREDFOLDS</Typography>
                </Box>
                <Box sx={SX_STYLES.desktopLinks}>
                    {
                        services.map((item, index) => 
                            <Box key={index}>
                                <RoundedOptionButton
                                    text={item.service}
                                    endIcon={item.icon}
                                    onClick={() => handleClick(item)}
                                    active={location.pathname === '/' + item.route}
                                />
                            </Box>
                        )
                    }
                </Box>
            </Box>
            <Button variant="text" sx={[SX_STYLES.buttonContact, SX_STYLES.desktopContact]} onClick={goToContactUs}>Contact Us</Button>
            <IconButton sx={SX_STYLES.hamburger} onClick={() => setDrawerOpen(true)}>
                <MenuIcon sx={{ color: COLORS.blueD66, fontSize: '3vh' }}/>
            </IconButton>
        </Box>
        <Drawer anchor='right' open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <Box sx={SX_STYLES.drawerContainer}>
                <Box sx={SX_STYLES.drawerHeader}>
                    <Box sx={SX_STYLES.logoContainer} onClick={() => { setDrawerOpen(false); navigate('/'); }}>
                        <Box component="img" sx={SX_STYLES.logoStyle} src={IMAGES.HIC_Logo} />
                        <Typography sx={SX_STYLES.logoName}>HUNDREDFOLDS</Typography>
                    </Box>
                    <IconButton onClick={() => setDrawerOpen(false)}>
                        <CloseIcon sx={{ color: COLORS.blueD66 }}/>
                    </IconButton>
                </Box>
                <List>
                    {services.map((item, index) =>
                        <ListItem button key={index} onClick={() => handleMobileNav(item)}>
                            <ListItemText primary={item.service} primaryTypographyProps={{ sx: SX_STYLES.drawerLinkText }}/>
                        </ListItem>
                    )}
                </List>
                <Box sx={SX_STYLES.drawerContactBtn}>
                    <Button variant="text" sx={SX_STYLES.buttonContact} onClick={handleMobileContact}>Contact Us</Button>
                </Box>
            </Box>
        </Drawer>
        </>
    );
}

export default NavigationBar;